import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../../modules/shared/shared.global-service';
import { selectFolder } from '../../../../../modules/content/store/person/person.selectors';

@Injectable()
export class ServiceDoctorsCertificatesModalStore extends ComponentStoreV2Factory {
}
